import { Component, Input, OnInit, Renderer2, HostListener, ElementRef, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BodisplayService } from '../../bodisplay/bodisplay.service';
import { BObjectModel, ConfigKey, QueovalItemModel } from '../../models';
import { CoreService, HttpService } from '../../services';
import { ToastService } from '../../toast';
import { DialogService } from '../../dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { b64EncodeUnicode } from '../../utilities';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-insertdoc-input',
  templateUrl: './insertdoc-input.component.html',
  styleUrls: ['./insertdoc-input.component.css']
})
export class InsertdocInputComponent implements OnInit, AfterViewInit {

  public model: BObjectModel;
  public path: string;
  public mobile: boolean;
  public maxUploadSize: string;
  public boHidden: boolean = true;

  public eraseDocxFileIfNewDocIsPDF: boolean = false;
  public onlyInput: boolean = false;
  private fFile: File | undefined;
  public fileIsPDF: boolean = false;
  
  public docIsReadOnly: boolean = false;
 

  @Input('file')
  set setFile(value: File | undefined) {
    if (!value)
      this.path = '';
    this.fFile = value;
  }

  @Input('item')
  set item(value: BObjectModel) {
    if (value !== null) {
      this.model = value;
    }
  }
  //#region Inputs pour le binding avec l'insertdoc UNIQUEMENT (à ne pas utiliser pour le q-insertdoc-input)
  @Input('boHidden')
  set setBoHidden(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.boHidden = true;
    } else {
      this.boHidden = value;
    }
  }
  @Input('onlyInput')
  set setOnlyInput(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.onlyInput = true;
    } else {
      this.onlyInput = value;
    }
  }
  @Input('eraseDocxFileIfNewDocIsPDF')
  set SetEraseDocxFileIfNewDocIsPDF(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.eraseDocxFileIfNewDocIsPDF = true;
    } else {
      this.eraseDocxFileIfNewDocIsPDF = value;
    }
  }

  public registerMode: string = 'REGISTERFILE';
  @Input('registerMode')
  set setRegisterMode(value: string) {
    if (value) {
      this.registerMode = value;
    }
  }
  //#endregion
  @Output() success: EventEmitter<boolean> = new EventEmitter<boolean>();

  //#region Outputs pour le binding avec l'insertdoc UNIQUEMENT (à ne pas utiliser pour le q-insertdoc-input)
  @Output() fileChange: EventEmitter<File> = new EventEmitter<File>();
  @Output() eraseDocxFileIfNewDocIsPDFChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  //#endregion

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event): void {
    this.setStyle();
  }


  constructor(
    private indParam: CoreService,
    private http: HttpClient,
    private httpService: HttpService,
    private render: Renderer2,
    private boservice: BodisplayService,
    private dialogservice: DialogService,
    private toastservice: ToastService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    if (this.model && this.model.IdDonneeFils && this.model.IdDonneeFils != "0") {
      this.httpService.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/DOC_IS_READ_ONLY/${this.model.IdDonneeFils}`).subscribe(
        (result: QueovalItemModel) => {
          this.docIsReadOnly = result.Boolean;
        });
    } else {
      this.docIsReadOnly = false;
    }
    //this.maxUploadSize = this.indParam.getConfigKey(ConfigKey.DOCSIZE);
    // Conversion octets en Mo pour l'affichage
    const sizeInMo: number = parseInt(this.indParam.getConfigKey(ConfigKey.DOCSIZE)) / 1000000;
    this.maxUploadSize = sizeInMo.toString();
    this.CheckFileIsPDF('');
    this.path = '';    
    this.mobile = window.innerWidth <= 1200 ? true : false;

  }

  ngAfterViewInit(): void {
    this.setStyle();
  }



  // #region FONCTIONS PUBLIQUES
  // chargment d'un nouveau fichier
  public onSelectChange(e: any): void {

    if (!e || !e.target || !e.target.files || e.target.files.length < 1) {
      this.CheckFileIsPDF('');
      this.path = '';
      this.fFile = undefined;
      return;
    }

    if (e.target.value == '') return;

    const fileName: Array<string> = e.target.files[0].name.split('.');
    const extension: string = fileName[fileName.length - 1];
    const extensionAutorized: Array<string> = ['xls', 'xlsx', 'docx', 'doc', 'txt', 'pdf', 'ppt', 'pptx', 'jpeg', 'gif', 'jpg', 'png', 'zip', 'rar'];
    const extensionValid: string | undefined = extensionAutorized.find((element: string) => {
      return element === extension.toLowerCase();
    });
    this.CheckFileIsPDF(extension);
    if (extensionValid) {
      if (e.target.files[0].size <= parseInt(this.indParam.getConfigKey(ConfigKey.DOCSIZE))) {
        this.path = e.target.files[0].name;
        this.fFile = e.target.files[0];
        if (!this.boHidden) {
          this.boservice.setDocxName(fileName[0]);
        }
        this.fileChange.emit(this.fFile);        
      } else {
        // A traduire
        //this.toastservice.showAlertToast(`${this.indParam.getTrad('ext_uploadSize')}`);
      }
    } else {
      this.toastservice.showAlertToast(`${this.indParam.getTrad('extensionUnautorized')}. ${this.indParam.getTrad('herearetheacceptedextensions')} : 'xls', 'xlsx', 'docx', 'doc', 'txt', 'pdf', 'ppt', 'pptx', 'jpeg', 'gif', 'jpg', 'png', 'zip', 'rar'`);
    }
    e.target.value = '';
  }
  public CheckFileIsPDF(extension: string): void {
    this.fileIsPDF = extension.toLowerCase() === 'pdf' && !!this.model && !!this.model.IdDonneeFils && this.model.IdDonneeFils != "0";
  }
  // Récupération des infos du bo pour l'upload
  public getEvent(model: BObjectModel): void {
    if (this.fFile !== undefined) {
      const fileName: string = b64EncodeUnicode(this.fFile.name);
      const ConfigFile: any = {
        responseType: 'arraybuffer' as 'arraybuffer',
        headers: { 'Queoval': this.indParam.AppParams.token, 'mode': 'INSERTDOC', 'fileName': fileName, 'IdDonnee': model.IdDonneeFils, 'IdRelation': model.IdRelation, 'GetIfExist': this.boHidden ? "1" : "0", 'eraseDocxFileIfNewDocIsPDF': this.eraseDocxFileIfNewDocIsPDF ? "1" : "0", 'RegisterMode': this.registerMode }
      };
      const formData: FormData = new FormData();
      formData.append('file', this.fFile, fileName);
      formData.append('name', fileName);
      formData.append('IDDONNEE', model.IdDonneeFils);
      formData.append('IDRELATION', model.IdRelation);
      formData.append('ISCHILD', 'TRUE');
      formData.append('mode', 'INSERTDOC');
      formData.append('token', this.indParam.AppParams.token);

      this.http.post(`${this.indParam.AppParams.apiUrl}api/Upload`, formData, ConfigFile).subscribe((data: any) => {
        this.dialogservice.showSplash(false);
        this.success.emit(true);
      },
        (error: any) => {
          this.toastservice.showAlertToast(`Une erreur est survenue lors de la sauvegarde de document`);
          this.dialogservice.showSplash(false);
          console.error(JSON.stringify(error));
          this.success.emit(false);
        }
      );
    } else {
      this.toastservice.showInfoToast(`Veuillez selectionner un document`);
      this.success.emit(false);
    }
  }

  public OnEraseDocxFileIfNewDocIsPDFChange(value: boolean): void {
    this.eraseDocxFileIfNewDocIsPDF = value;
    this.eraseDocxFileIfNewDocIsPDFChange.emit(value);
  }

  //#endregion

  // #region FONCTIONS PRIVATE

  // Modifie le style en fonction de la taille du media
  setStyle(): void {
    this.mobile = window.innerWidth <= 1200;
  }
  // #endregion

}
